import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import methodModel from "../../../methods/methods";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import Sidebar from "../sidebar";
import { FiBell, FiMenu, FiX } from "react-icons/fi";
import { LuLogOut, LuUser } from "react-icons/lu";
import { GoLock } from "react-icons/go";
import { FaArrowDown, FaChevronDown } from "react-icons/fa";
import socketModel from "../../../models/socketModel";
import ApiClient from "../../../methods/api/apiClient";
import { useTranslation } from "react-i18next";
import FormControl from "../../common/FormControl";
import loader from "../../../methods/loader";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Html = ({ isOpen, toggle, user, isOpen1, Logout }) => {
  const { t, i18n } = useTranslation();

  const history = useNavigate();
  const [notificationData, setNotificationData] = useState([]);
  console.log(notificationData, "notificationData");
  const [isOpenNotification, setIsOpenNotification] = useState(false);
  const [notificationTotal, setnotificationTotal] = useState(0);

  const [showSuggestions, setShowSuggestions] = useState(false);
  const suggestionsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // useEffect(() => {
  //   getNotifications();
  //   const loadGoogleTranslateScript = () => {
  //     if (!document.getElementById("google_translate_script")) {
  //       const addScript = document.createElement("script");
  //       addScript.id = "google_translate_script";
  //       addScript.type = "text/javascript";
  //       addScript.src =
  //         "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";

  //       addScript.onerror = (err) => {
  //         console.error("Google Translate script failed to load", err);
  //       };

  //       document.body.appendChild(addScript);
  //     }

  //     window.googleTranslateElementInit = () => {
  //       try {
  //         new window.google.translate.TranslateElement(
  //           { pageLanguage: "en", includedLanguages: "en,ja" },
  //           "google_translate_element"
  //         );
  //       } catch (e) {
  //         console.error("Translate Element failed to initialize", e);
  //       }
  //     };
  //   };

  //   const elementContainer = document.getElementById(
  //     "google_translate_element"
  //   );
  //   if (!elementContainer || elementContainer.innerHTML.trim() === "") {
  //     loadGoogleTranslateScript();
  //   }
  //   // socketModel.emit("user-online", { UserId: user?._id || user?.id });
  // }, []);

  useEffect(() => {
    if (user?.role === "admin" || user?.role === "subAdmin") return;
    const location = window.location.pathname;
    const userPermissions = user?.permissions?.[0] || {};
    const routePermissionMap = {
      "/dashboard": "readDashboard",
      "/location": "readLocation",
      "/manager": "readManager",
      "/staff": "readStaff",
      "/performance": "readperformance",
      "/store": "readstore",
      "/supplier": "readsupplier",
    };
    const basePath = `/${location.split("/")[1]}`;
    const requiredPermission = routePermissionMap[basePath];
    if (requiredPermission && !userPermissions[requiredPermission]) {
      history("/profile");
    }
  }, [user, history]);

  const handleToggleNotification = () => {
    setIsOpenNotification(!isOpenNotification);
    setShowSuggestions(true);
  };

  const getNotifications = () => {
    ApiClient.get(`dash/shift/notification?status=unread`).then((res) => {
      if (res.success) {
        // setNotificationData(res.data);
        // setnotificationTotal(res?.total);
      }
    });
  };

  const viewNotification = (id, removeId) => {
    let payload = {
      id: removeId,
      status: "read",
    };
    ApiClient.put("dash/update/status", payload).then((res) => {
      if (res.success) {
        setIsOpenNotification(false);
        getNotifications();
        history(`/shift`);
      }
    });
  };

  useEffect(() => {
    getNotifications();
    socketModel.emit("shift-notification-for-admin");
    const handleNotificationList = (response) => {
      if (response.success) {
        const newNotifications =
          response?.notitificationObj?.findAllNotification || [];
        const totalFromSocket =
          response?.notitificationObj?.totalNotification || 0;

        setNotificationData(newNotifications);

        setnotificationTotal(totalFromSocket);
      }
    };

    socketModel.on("shift-notification-for-admin", handleNotificationList);
    return () => {
      socketModel.off("shift-notification-for-admin", handleNotificationList);
    };
  }, []);

  const handleLanguageChange = (e) => {
    i18n.changeLanguage(e);
  };

  const clearall = (e) => {
    e.preventDefault();
    loader(true);
    ApiClient.get(
      `dash/shift/notification/clear?managerId=${user?.id || user?._id}`
    ).then((res) => {
      if (res.success) {
        setnotificationTotal(0);
        setNotificationData([]);
      }
      loader(false);
    });
  };

  return (
    <nav
      component="header"
      className={`${
        isOpen ? "min-sidebar w-[calc(100%-80px)]" : "w-[calc(100%-290px)] "
      } shadow-btn py-1.5 bg-[#f8f9fa] border-b  fixed transition-[width] duration-300 ml-auto right-0 z-10 flex items-center !px-2 sm:!px-5
      `}
    >
      <div id="logoutBtn" onClick={() => Logout()}></div>
      <button
        onClick={toggle}
        className="h-9 w-9 shrink-0 shadow-btn hover:shadow-none p-1 rounded-lg border border-gray-100 !text-primary"
      >
        {!isOpen ? (
          <FiMenu className="w-full h-full" />
        ) : (
          <FiX className="w-full h-full" />
        )}
      </button>

      <div className="flex items-center gap-2 sm:gap-4 ml-auto">
        {/* <div id="google_translate_element"></div> */}
        <div>
          <FormControl
            type="select"
            theme="search"
            options={[
              { name: "English", id: "en" },
              { name: "日本語", id: "ja" },
            ]}
            value={i18n.language}
            onChange={handleLanguageChange}
          />
        </div>
        <div
          className="bg-[#F3F6F9] h-[30px] w-[30px] rounded-md flex items-center justify-center mr-3 relative cursor-pointer"
          onClick={handleToggleNotification}
        >
          <span className="bg-[#3C73AA] flex items-center justify-center h-[15px] w-[15px] rounded-full text-white text-[8px] absolute top-[-6px] right-[-4px] leading-[0px]">
            {notificationTotal}
          </span>
          <FiBell className="text-[#67748E]" />
        </div>
        <Menu as="div" className="relative">
          <div>
            <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-1 sm:px-3 py-1 text-sm font-semibold text-gray-900 ">
              <div className="flex items-center gap-2">
                <div className="flex items-center">
                  <img
                    alt="image"
                    src={methodModel.userImg(user.image)}
                    className="h-[48px] w-[48px] min-h-[48px] min-w-[48px] rounded-full object-cover"
                  />
                  <div className="ml-2 text-left hidden md:block">
                    <span className="capitalize">{user.fullName}</span>
                    <p className="grayCls capitalize mb-0 text-capitalize">
                      {user?.role === "admin"
                        ? t("superadmin")
                        : t("subadmin") || user?.role}
                    </p>
                  </div>
                </div>
                <FaChevronDown />
                {/* <i
                  className="fa fa-angle-down top-1 relative h-5 w-5 text-gray-400"
                  aria-hidden="true"
                /> */}
              </div>
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/profile"
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block px-4 py-2 text-sm flex items-center gap-2"
                      )}
                    >
                      <LuUser /> {t("profile")}
                    </Link>
                  )}
                </Menu.Item>

                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/profile/change-password"
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block px-4 py-2 text-sm flex items-center gap-2"
                      )}
                    >
                      <GoLock />
                      {t("changePassword")}
                    </Link>
                  )}
                </Menu.Item>

                <Menu.Item className="divide-y-1 divide-gray-800 pt-1  mt-2">
                  <p className="border-t"></p>
                </Menu.Item>

                <Menu.Item className="">
                  {({ active }) => (
                    <span
                      onClick={() => Logout()}
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block w-full px-4 py-2 text-left text-sm ancortag flex items-center gap-2 cursor-pointer"
                      )}
                    >
                      <LuLogOut /> {t("logout")}
                    </span>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
      {isOpen1 ? (
        <div className="w-100 mobi-dropdown">
          <Sidebar />
        </div>
      ) : (
        <></>
      )}
      {isOpenNotification && showSuggestions && (
        <div
          ref={suggestionsRef}
          className="absolute top-[62px] right-[12px] z-50 w-64 bg-white shadow-lg rounded-md border-[1px] border-[#4d8992]"
        >
          <p className="p-[10px] bg-[#3C73AA] text-white text-[14px] rounded-t-[4px]">
            {t("notifications")}
            {/* <span className="cursor-pointer" onClick={(e) => clearall(e)}>
              Clear All
            </span> */}
          </p>
          {/* <p></p> */}
          <div className="py-2 px-1 max-h-[350px] overflow-auto">
            {notificationData.length > 0 ? (
              notificationData.map((itm) => (
                <div
                  key={itm._id}
                  onClick={() => viewNotification(itm.orderId, itm._id)}
                  className="flex gap-1 mb-1 items-center cursor-pointer hover:bg-gray-100 p-2 border-b-[1px] border-gray-200"
                >
                  <div className="relative">
                    <img
                      src={methodModel.noImg(
                        itm?.addedBy?.image || itm?.addedByDetails?.image
                      )}
                      className="zoom_img min-w-[25px] w-[25px] min-h-[25px] h-[25px] object-cover cursor-pointer rounded-full "
                      alt="NO Image"
                    />
                  </div>
                  <p className="text-gray-700 text-[12px] leading-[14px] capitalize">
                    <span>
                      {itm?.addedBy?.fullName || itm?.addedByDetails?.fullName}
                    </span>{" "}
                    {t("requestedShiftRequest")}
                  </p>
                  <p></p>
                </div>
              ))
            ) : (
              <p className="text-xs text-slate-500 text-center">
                {t("noNotifications")}
              </p>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Html;
